import styled, { css } from 'styled-components/macro';

import { COLORS } from 'utils/styles/colors';
import { deviceMax, deviceMin } from 'utils/styles/breakpoints';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { Images } from 'assets/images';
import { FLEX_CONTAINER } from 'utils/styles/flex';

const inputErrorBorder = css`
  border-bottom: 2px solid ${COLORS.red};
`;

const inputDefaultBorder = css`
  border-bottom: 2px solid ${COLORS.darkGray};
`;

export const Input = styled.input`
  width: 100%;
  height: 45px;
  padding-left: 5px;
  margin-bottom: 30px;
  background: transparent;
  color: ${COLORS.darkGray};
  ${({ error }) => (error ? inputErrorBorder : inputDefaultBorder)};
  ${FONTS.font24}

  :last-child {
    margin-bottom: 0px;
  }

  ::placeholder {
    color: ${COLORS.darkGray};
  }

  @media ${deviceMax.laptopM} {
    ${FONTS.font16}
  }

  @media ${deviceMax.tablet} {
    ${FONTS.font24}
  }

  @media ${deviceMax.mobileL} {
    ${FONTS.font12}
  }
`;

export const Container = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn}
  width: 100%;
  position: relative;
  z-index: 1;
  border-radius: 25px;
  background: rgba(255, 255, 255, 0.75);
  height: 90vh;
  max-height: 763px;

  @media ${deviceMin.mobileS} {
    width: 240px;
    max-height: 386px;
  }

  @media ${deviceMin.mobileL} {
    width: 366px;
    max-height: 500px;
  }

  @media ${deviceMin.tablet} {
    width: 579px;
    max-height: 500px;
  }

  @media ${deviceMin.laptopL} {
    width: 415px;
    max-height: 600px;
  }

  @media ${deviceMin.desktop} {
    width: 770px;
    max-height: 620px;
  }
`;

export const GeneralErrorMessage = styled.p`
  ${FONTS.font16}
  color: ${COLORS.red};
  margin-top: 20px;
  text-align: center;
  visibility: ${({ error }) => (error ? 'visible' : 'hidden')};
`;

export const Form = styled.form`
  width: 100%;
  display: block;

  .text-field {
    margin-bottom: 16px;

    @media ${deviceMax.tablet} {
      height: 32px;
    }

    @media ${deviceMax.mobileS} {
      margin-bottom: 20px;
      height: 23px;
    }
  }

  .red {
    ${FONTS.font14}
    color: ${COLORS.red};
  }

  .verification-inputs {
    ${FLEX_CONTAINER.FlexCenterRow}
    gap: 30px;
    width: 80%;
    margin: 0 auto;

    input {
      text-align: center;
    }

    @media ${deviceMax.laptopM} {
      gap: 20px;
    }

    @media ${deviceMax.tablet} {
      gap: 27px;
    }

    @media ${deviceMax.mobileS} {
      gap: 17px;
      width: 100%;
      margin-left: 0;
    }
  }

  .submit-btn {
    width: 100%;
    ${FONT_FAMILY.FontBold}

    @media ${deviceMin.mobileS} {
      height: 38px;
      ${FONTS.font12}
    }

    @media ${deviceMin.mobileL} {
      height: 52px;
      ${FONTS.font14}
    }

    @media ${deviceMin.tablet} {
      height: 68px;
      ${FONTS.font16}
    }

    @media ${deviceMin.laptopL} {
      height: 58px;
      ${FONTS.font16}
    }

    @media ${deviceMin.desktop} {
      height: 62px;
      ${FONTS.font24}
    }
  }

  .verify {
    @media ${deviceMax.tablet} {
      margin-top: 50px;
    }

    @media ${deviceMax.mobileS} {
      margin-top: 50px;
    }
  }

  .inputs-block {
    ${FLEX_CONTAINER.FlexColumn}
    width: 100%;

    label {
      ${FONT_FAMILY.FontRegular}
      color: ${COLORS.darkGray};

      @media ${deviceMin.mobileS} {
        ${FONTS.font12}
      }

      @media ${deviceMin.tablet} {
        ${FONTS.font14}
      }

      @media ${deviceMin.desktop} {
        ${FONTS.font16}
      }
    }
  }

  .reset-password {
    > div:first-child {
      margin-bottom: 50px;
      margin-top: 40px;

      @media ${deviceMax.laptopM} {
        margin-bottom: 36px;
        margin-top: 20px;
      }

      @media ${deviceMax.tablet} {
        margin-bottom: 40px;
      }

      @media ${deviceMax.mobileS} {
        margin-top: 20px;
        margin-bottom: 13px;
      }
    }
  }
`;

export const MainAuthContainer = styled.div`
  height: 100%;
  background-image: url(${Images.loginMainBackground});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;
